export const CHANGE_REDIRECT_URI = "change_redirect_uri"